import { autoserializeAs } from "cerialize";
import TUKGrowthMetrics from "./TUKGrowthMetrics";
import TUKCashflowTrend from "./TUKCashflowTrend";
import TUKAllocation from "./TUKAllocation";
import EntityAware from "../EntityAware";

export default class TUKDashboardAnalytics implements EntityAware {

    @autoserializeAs(TUKGrowthMetrics)
    public growth_metrics: TUKGrowthMetrics = new TUKGrowthMetrics();

    @autoserializeAs(TUKCashflowTrend)
    public cashflow_trends: TUKCashflowTrend[] = [];

    @autoserializeAs(TUKAllocation)
    public income_allocation: TUKAllocation[] = [];

    @autoserializeAs(TUKAllocation)
    public expense_allocation: TUKAllocation[] = [];
}
